<template>
    <auth-layout :isPlain="true" :progress="isSent ? 100 : 0" :isProgressBarHidden="true">
        <template v-if="showNotFoundPage">
            <common-content-wrapper width="large">
                <common-page-header
                    :heading="$t('pages.auth.reset_password.heading.error')"
                    :content="$t('pages.auth.reset_password.description.error')"
                ></common-page-header>
            </common-content-wrapper>

            <common-content-wrapper width="small">
                <common-button
                    :label="$t('pages.auth.reset_password.send_again')"
                    :route="{ name: 'auth.forgot-password' }"
                    type="primary"
                    size="large"
                ></common-button>
            </common-content-wrapper>
        </template>

        <template v-else-if="isSent">
            <common-content-wrapper width="large">
                <common-page-header :heading="$t('pages.auth.reset_password.heading.done')"></common-page-header>
            </common-content-wrapper>

            <common-content-wrapper width="small">
                <common-button
                    :label="$t('pages.auth.reset_password.back_to_login')"
                    :route="{ name: 'auth.login' }"
                    type="primary"
                    size="large"
                ></common-button>
            </common-content-wrapper>
        </template>

        <template v-else>
            <common-content-wrapper width="large">
                <common-page-header
                    :heading="pageTitle"
                    :content="$t('pages.auth.reset_password.description.initial')"
                ></common-page-header>
            </common-content-wrapper>
            <common-page-header
                v-if="$route.query.email"
                class="page-header__email"
                :isCenter="true"
                :content="$route.query.email.replace(/\s+/g, '')"
            ></common-page-header>

            <common-content-wrapper width="small">
                <reset-password-form @sent="afterSent()" @email-sent="emailSend()"></reset-password-form>
            </common-content-wrapper>
        </template>
    </auth-layout>
</template>

<script>
    import { mapGetters } from 'vuex'
    import PageWithTitleMixin from 'mixins/PageWithTitleMixin'
    import PageWithDataMixin from 'mixins/PageWithDataMixin'
    import AuthLayout from 'components/layouts/AuthLayout'
    import ResetPasswordForm from 'components/forms/AuthResetPasswordForm'

    export default {
        mixins: [PageWithTitleMixin, PageWithDataMixin],

        components: {
            AuthLayout,
            ResetPasswordForm,
        },

        data() {
            return {
                isSent: false,
                notificationMessage: '',
            }
        },

        computed: {
            ...mapGetters({
                showNotFoundPage: 'ui/getShowNotFoundPage',
            }),

            pageTitle() {
                return this.$route.query.email
                    ? this.$t('pages.auth.reset_password.heading.set_password')
                    : this.$t('pages.auth.reset_password.heading.initial')
            },
        },

        methods: {
            afterSent() {
                this.isSent = true
            },
        },
    }
</script>
